import styled from 'styled-components';

import { Color } from '../../enums';
import { StyledComponent } from '../../interfaces';
import { Image } from '../image/image.component';

export const Container: StyledComponent<'div'> = styled.div`
  width: 100%;
  padding: 16px;
  display: flex;
  border: 1px solid ${Color.Gray300};
`;

export const ImageContainer: StyledComponent<'div'> = styled.div`
  width: 124px;
  height: 162px;
  margin-right: 16px;
  flex-shrink: 0;
`;

export const ImagePlaceholder: StyledComponent<'div'> = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid ${Color.Gray200};
  width: 100%;
  height: 100%;
`;

export const ImageElement: StyledComponent<typeof Image> = styled(Image)`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const ArtistDetailsContainer: StyledComponent<'div'> = styled.div`
  display: flex;
  flex-direction: column;
`;
